
//动态获取url
function getUrl(url, queryConfig) {
  var _str = "";
  for (var obj in queryConfig) {
    if (!this.isNull(queryConfig[obj])) {
      _str += obj + "=" + queryConfig[obj] + "&";
    }
    }
    if (_str.length > 0) {
        return url + "?" + _str.substring(0, _str.length - 1);
    } else {
        return url
    }
}

//判空方法
function isNull(val = "") {
    if (val == undefined || val == null) {
      return true;
    }
    var str = val.toString().replace(/(^\s*)|(\s*$)/g, ""); //去除空格;
    if (str == "" || str == undefined || str == null) {
      return true;
    }
}
  
export default {
    getUrl,
    isNull
}


// WEBPACK FOOTER //
// ./src/utils/convertData.js